<template>
  <span
    class="ml-2 text-h6"
    v-if="paymentMethods.length === 1"
    v-text="paymentMethod.name"
  />
  <v-slide-group
    v-else-if="fullCashControl"
    v-model="selected"
    mandatory
    show-arrows
  >
    <v-slide-item
      v-for="item in paymentMethods"
      :key="item.id"
      v-slot="{ active, toggle }"
    >
      <h-button
        :payment-method="item"
        :active="active"
        @toggle="toggle"
      />
    </v-slide-item>
  </v-slide-group>
  <v-item-group
    v-else
    v-model="selected"
    mandatory
  >
    <v-item
      v-for="item in paymentMethods"
      :key="item.id"
      v-slot="{ active, toggle }"
    >
      <h-button
        :payment-method="item"
        :active="active"
        @toggle="toggle"
      />
    </v-item>
  </v-item-group>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import HButton from './PaymentMethodsButton'

  export default {
    components: {
      HButton,
    },

    computed: {
      ...mapState('cashControl/form', [
        'paymentMethods',
      ]),
      ...mapGetters('cashControl/form', [
        'paymentMethod',
        'fullCashControl',
      ]),
      selected: {
        get () {
          return this.$store.state.cashControl.form.selectedPaymentMethod
        },
        set (v) {
          this.$store.commit('cashControl/form/selectedPaymentMethod', v)
        },
      },
    },
  }
</script>
